import { render, staticRenderFns } from "./CurvaSTab.vue?vue&type=template&id=54cea8f0&scoped=true&"
import script from "./CurvaSTab.vue?vue&type=script&lang=js&"
export * from "./CurvaSTab.vue?vue&type=script&lang=js&"
import style0 from "./CurvaSTab.vue?vue&type=style&index=0&id=54cea8f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cea8f0",
  null
  
)

export default component.exports